
import { Component, Vue } from 'vue-property-decorator';
import {jsPDF} from 'jspdf';
@Component
export default class RouterComponent extends Vue {
}
